// Roles that can access the staff portal
export const STAFF_PORTAL_ROLES = ['TEACHER', 'PRINCIPAL', 'ADMIN', 'MANAGER', 'COORDINATOR'];

// Roles that can access principal-only features (Staff, Settings, Payments)
export const PRINCIPAL_ROLES = ['PRINCIPAL', 'ADMIN'];

export const canAccessStaffPortal = (role: string | undefined): boolean => !!role && STAFF_PORTAL_ROLES.includes(role);

export const canAccessPrincipalFeatures = (role: string | undefined): boolean => !!role && PRINCIPAL_ROLES.includes(role);
